var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 321.7 321.7",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st2{opacity:.63;fill:#bc446f}.st5{fill:#68287f}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M109.5 65.1l11.3-4.4s14.5 23.5 34.5 25.1c20.1 1.6 37.4-5.8 48.9-23.9l11.7 4.2s-13.6 7.6-23.2 30.9c-9.6 23.3-6 49.5-6 49.5H138c0 .2 4.9-58.1-28.5-81.4z",
    fill: "#bc446f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M104.8 66.9s8.4 9.9 9.9 24.1c1.1 10.8-5.9 23.9-8.9 34.1 0 0-3 4.1 7.7 30.1l-4.3 82.9c30.7 25.6 76.9 21.7 104.1.8 0 0-12.8-55.3-7.4-87 0 0 7.3-10.7 8.9-21.6 0 0-4-8.2-5.1-16-.5-3.3-1.3-13.4.3-23.1 2-12.1 7.9-24.2 7.9-24.2l-13.7-5s4 14 1.1 28.4c-2.4 12-10.8 24.4-20 29.1-11 5.6-25.9 9.7-38 5.5-9.5-3.3-14.5-9.4-20.6-18-3.4-4.8-6.7-12.2-8-17.1-4.4-16.1 1.4-28.8 2-29.1l-15.9 6.1z",
    fill: "#ef5972"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M172.8 164.3c-23.7 0-59.3-9.1-59.3-9.1l-4.3 82.9c12.5 10.4 27.5 15.9 42.8 17.4-.8-2.5-1.8-5.2-3.1-7.9-27.8-61.3 23.9-83.3 23.9-83.3zm31.7-65.8s-14.8 25.6-11.5 27.7 11.5-27.7 11.5-27.7zm1.4 0s-7.7 27.2-2 27.8c5.5.7 2-27.8 2-27.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M127.8 109.9c6 8.8 12.6 15.3 23.6 17.4 5.8 1 12.9 1 22.3-1.9 13.1-4.2 18.8-8.7 24.1-16.7 2.7-4.2 4.8-8.7 6.1-13.4-3.5 8.6-9.6 17.6-17.6 22.3-4.2 2.2-8.7 4.1-13.3 5.4-14.8 4.4-29 3.2-39.2-8.5-6.9-7.5-11.9-15.6-15.1-24.6.5 2.4 1.3 4.7 2.2 7 2.5 6.5 4.5 9.5 6.9 13zm-17.4 127.6c2.4-43.7.3-4.7 2.1-40.8 1.3-26.9 1-20 1.9-41.7 0-.1-10.2-23.4-8.3-29.3 0-.1.1-.3.1-.3 4.8-14.4 7.9-21.4 8.4-29.6-1.1 9.4-5.9 18.6-9.7 29.6-.6 1.8 0 5.7.3 7.6 1.4 7.2 4.6 15.9 7.2 22.3-1 14.9-1 16.9-2.4 41.2-.2 4.3.8-15.6-2.2 42.1.6.4 9.9 8.9 25.2 14 26.6 8.9 59.1 3.2 80.2-13.7-7.5 5.5-73.8 22.4-102.8-1.4z",
    fill: "#af3c54"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M121.5 86.9c.7 2.3-1.2 4.9-4.2 5.9s-6.1-.2-6.8-2.5c-.7-2.3 1.2-4.9 4.2-5.9s6.1.2 6.8 2.5z",
    fill: "#bc33c4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M113.6 92.9c3.5.6 6.8-1.5 7.6-4 .9-2.6-1.6-5.2-5.9-4.6 4-1.2 7.6 1.4 6.5 4.8-.5 1.6-1.9 2.9-3.4 3.5-1.5.7-3.2.8-4.8.3z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M113.8 85.7s-2.3.4-1.9 2.9c.3 2.4 2.5 3.4 3.1 1 .6-2.4 1.6-4.4-1.2-3.9z",
    opacity: 0.29,
    fill: "#f6bcff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M212.3 92.7c-.4 2.4-3.2 3.9-6.4 3.4-3.1-.5-5.4-2.8-5-5.2.4-2.4 3.2-3.9 6.4-3.4 3.1.5 5.4 2.8 5 5.2z",
    fill: "#bc33ab"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M207.8 87.6c4.1 1.4 5.2 4.9 3.2 6.8-1.8 1.9-5.7 2.2-8.5.2 1.1 1.1 2.8 1.8 4.4 1.9 1.6.1 3.4-.4 4.6-1.6 2.5-2.7.4-6.7-3.7-7.3z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M205.9 88.2s-2.2-.6-3 1.7c-.8 2.3.7 4.1 2.3 2.2 1.6-1.8 3.4-3.1.7-3.9z",
    opacity: 0.29,
    fill: "#f62aff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M116.6 95.9s-9.8 27.1-4.8 29c5.1 1.8 4.8-29 4.8-29zm2.3 6.2v.4c.4.4.9 22.6 4.9 24 3.9 1.4-4.9-24.4-4.9-24.4z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg6);
export default __webpack_public_path__ + "static/media/6.0b7edea0aa71ee27b1c4c176929248b9.svg";
export { ForwardRef as ReactComponent };